import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ValueProps } from './components/ValueProps';
import { UseCases } from './components/UseCases';
import { TransferProcess } from './components/TransferProcess';
import { OfferForm } from './components/OfferForm';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { ConsentProvider } from './context/ConsentContext';
import { CookieConsentBanner } from './components/CookieConsentBanner';

export const App: React.FC = () => {
  return (
    <ConsentProvider>
      <div className="relative min-h-screen bg-[#040711] text-slate-100 selection:bg-emerald-500 selection:text-slate-950 font-sans">
        {/* Background ambient grid pattern */}
        <div className="fixed inset-0 bg-grid-pattern opacity-60 pointer-events-none z-0"></div>

        {/* Main Content */}
        <div className="relative z-10 flex flex-col min-h-screen">
          <Header />
          
          <main className="flex-grow">
            <Hero />
            <ValueProps />
            <UseCases />
            <TransferProcess />
            <OfferForm />
            <FAQ />
          </main>

          <Footer />
        </div>

        {/* Google-Style Cookie & Tracking Consent Backdrop Banner */}
        <CookieConsentBanner />
      </div>
    </ConsentProvider>
  );
};

export default App;
